/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingTaxAmountDto } from './traveline-booking-tax-amount-dto';
import {
    TravelineBookingTaxAmountDtoFromJSON,
    TravelineBookingTaxAmountDtoFromJSONTyped,
    TravelineBookingTaxAmountDtoToJSON,
    TravelineBookingTaxAmountDtoToJSONTyped,
} from './traveline-booking-tax-amount-dto';

/**
 * Total for entire extra stays
 * @export
 * @interface TravelineExtraStaysTotalDto
 */
export interface TravelineExtraStaysTotalDto {
    /**
     * Price excluding taxes and fees payable at check-in
     * @type {number}
     * @memberof TravelineExtraStaysTotalDto
     */
    priceBeforeTax: number;
    /**
     * Amount of taxes and fees payable at check-in
     * @type {number}
     * @memberof TravelineExtraStaysTotalDto
     */
    taxAmount: number;
    /**
     * Taxes and fees payable at check-in
     * @type {Array<TravelineBookingTaxAmountDto>}
     * @memberof TravelineExtraStaysTotalDto
     */
    taxes?: Array<TravelineBookingTaxAmountDto> | null;
}

/**
 * Check if a given object implements the TravelineExtraStaysTotalDto interface.
 */
export function instanceOfTravelineExtraStaysTotalDto(value: object): value is TravelineExtraStaysTotalDto {
    if (!('priceBeforeTax' in value) || value['priceBeforeTax'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    return true;
}

export function TravelineExtraStaysTotalDtoFromJSON(json: any): TravelineExtraStaysTotalDto {
    return TravelineExtraStaysTotalDtoFromJSONTyped(json, false);
}

export function TravelineExtraStaysTotalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineExtraStaysTotalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceBeforeTax': json['priceBeforeTax'],
        'taxAmount': json['taxAmount'],
        'taxes': json['taxes'] == null ? undefined : ((json['taxes'] as Array<any>).map(TravelineBookingTaxAmountDtoFromJSON)),
    };
}

  export function TravelineExtraStaysTotalDtoToJSON(json: any): TravelineExtraStaysTotalDto {
      return TravelineExtraStaysTotalDtoToJSONTyped(json, false);
  }

  export function TravelineExtraStaysTotalDtoToJSONTyped(value?: TravelineExtraStaysTotalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceBeforeTax': value['priceBeforeTax'],
        'taxAmount': value['taxAmount'],
        'taxes': value['taxes'] == null ? undefined : ((value['taxes'] as Array<any>).map(TravelineBookingTaxAmountDtoToJSON)),
    };
}

